module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bs-a9ddb124f725485b9445976c1db059b0.svg";